import * as yup from 'yup'
import { driverJurisdictionValidation } from './driverJurisdictionValidation'
import { PersonDto } from './personDto'

export class InboundTripDriverInformationDto {
  driverCrewMember?: string = undefined
  driverVehiclePlate?: string = undefined
  driverVehicleCountry?: string = undefined
  driverVehicleState?: string = undefined
  driverTrailerPlate?: string = undefined
  driverTrailerCountry?: string = undefined
  driverTrailerState?: string = undefined
  driverPerson?: PersonDto = undefined
}

export const inboundTripDriverInformationValidationSchema = yup.object({
  driverPerson: yup.object().nullable(),
  driverCrewMember: yup.string().max(200, 'Crew Member cannot be more than 200 characters.').nullable(),
  driverVehiclePlate: yup.string().max(200, 'Vehicle Plate cannot be more than 200 characters.').nullable(),
  driverVehicleCountry: driverJurisdictionValidation('Vehicle Country'),
  driverVehicleState: driverJurisdictionValidation('Vehicle State/Province'),
  driverTrailerPlate: yup.string().max(200, 'Trailer Plate cannot be more that 200 characters.').nullable(),
  driverTrailerCountry: driverJurisdictionValidation('Trailer Country'),
  driverTrailerState: driverJurisdictionValidation('Trailer State/Province')
})
